module.exports = __webpack_public_path__ + "catalog/items/outdoor/kidney-swimming-pool/kidney-swimming-pool.svg";